// @flow
import * as React from 'react';
import styled from 'styled-components';
import { Space, SpaceDiv } from './../Space';

export const Separator = styled(Space)`
  height: 1px;
  background: ${({ bg = 'grey-3' }) => `var(--color-${bg})`};
`;

export const DivSeparator = styled(SpaceDiv)`
  height: 1px;
  background: ${({ bg = 'digital-gray-2' }) => `var(--color-${bg})`};
`;

export const VSeparator = styled(Space)`
  width: 1px;
  ${({ height = '0px' }) => `height: ${height}`};
  background: ${({ bg = 'grey-3' }) => `var(--color-${bg})`};
`;

export const renderDefaultSeparator = () => <Separator />;
export const renderWhiteSeparator = () => <Separator bg="white" />;
